import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lcon-splx-opcc-ms12',
  templateUrl: './lcon-splx-opcc-ms12.component.html',
  styleUrls: ['./lcon-splx-opcc-ms12.component.css']
})
export class LconSplxOpccMs12Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
